var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "modules-wrap" }, [
    _c(
      "div",
      { staticClass: "table" },
      [
        _vm.is_print_member_no == 1
          ? _c(
              "el-collapse",
              { attrs: { accordion: "" } },
              _vm._l(_vm.tableData, function (item, index) {
                return _c(
                  "el-collapse-item",
                  { key: item[_vm.id], staticClass: "table-row" },
                  [
                    _c("template", { slot: "title" }, [
                      _c("div", { staticClass: "table-row-header" }, [
                        _c("div", { staticClass: "header-content" }, [
                          _c("div", { staticClass: "content-left" }, [
                            _vm._v(
                              " " +
                                _vm._s(`${index + 1}# ${item.product_title}`) +
                                " "
                            ),
                          ]),
                          _c("div", [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("总件数："),
                            ]),
                            _vm._v(_vm._s(item.product_number) + "  /  "),
                            _c("span", { staticClass: "label" }, [
                              _vm._v("等级："),
                            ]),
                            _vm._v(_vm._s(item.product_grade) + "  /  "),
                            _c("span", { staticClass: "label" }, [
                              _vm._v("规格："),
                            ]),
                            _vm._v(_vm._s(item.product_spec) + " "),
                          ]),
                        ]),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "print-btn",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.onHandlePrint(item)
                            },
                          },
                        },
                        [_vm._v("打印标签")]
                      ),
                    ]),
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: item.order_detail_list,
                          border: true,
                          "header-cell-style": {
                            color: "#333333",
                            background: "#EFF6FF",
                          },
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "logistics_name",
                            label: "城市仓名称",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "delivery_name",
                            label: "自提点名称",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "vehicle_no",
                            label: "车位号",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "sort_code",
                            label: "坑位号",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "member_name",
                            label: "客户名称",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "member_mobile",
                            label: "客户电话",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "qty",
                            label: "订货数量",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "no_print_num",
                            label: "未打印数量",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "address",
                            label: "功能",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleEdit(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("打印标签")]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  2
                )
              }),
              1
            )
          : _c(
              "div",
              _vm._l(_vm.tableData, function (item, index) {
                return _c(
                  "div",
                  {
                    key: item[_vm.id],
                    staticClass: "table-row",
                    staticStyle: { display: "flex" },
                  },
                  [
                    _c("div", { staticClass: "table-row-header" }, [
                      _c("div", { staticClass: "header-content" }, [
                        _c("div", { staticClass: "content-left" }, [
                          _vm._v(
                            " " +
                              _vm._s(`${index + 1}# ${item.product_title}`) +
                              " "
                          ),
                        ]),
                        _c("div", [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("总件数："),
                          ]),
                          _vm._v(_vm._s(item.product_number) + "  /  "),
                          _c("span", { staticClass: "label" }, [
                            _vm._v("等级："),
                          ]),
                          _vm._v(_vm._s(item.product_grade) + "  /  "),
                          _c("span", { staticClass: "label" }, [
                            _vm._v("规格："),
                          ]),
                          _vm._v(_vm._s(item.product_spec) + " "),
                        ]),
                      ]),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "print-btn",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.onHandlePrint(item)
                          },
                        },
                      },
                      [_vm._v("打印标签")]
                    ),
                  ]
                )
              }),
              0
            ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }